'use strict';

var _ = require('lodash');
var turfEnvelope = require('turf-envelope');
var turfCentroid = require('turf-centroid');
var RoutePathJSON = require('./RoutePath.json');
var RouteLabelJSON = require('./routeLabel.json');

module.exports = {

  DASH_COLOR: '#AEB7BC',
  PATH_COLOR: '#FFF',

  getRoutePaths: function getRoutePaths (latlngs, index) {
    var _this = this;
    var isOdd = index % 2 !== 0;
    var paths = [];

    // if odd, add two paths: one solid, one dashed
    if (isOdd) {
      paths.push(this.createRoutePath(latlngs, {
        style: {
          color: _this.PATH_COLOR
        }
      }));
      paths.push(this.createRoutePath(latlngs, {
        style: {
          color: _this.DASH_COLOR
        },
        dashArray: '5, 10'
      }));
    } else {
      paths.push(this.createRoutePath(latlngs, {
        style: {
          color: _this.PATH_COLOR
        }
      }));
    }

    return paths;
  },

  createRoutePath: function createRoutePath (latlngs, properties) {
    var route = _.clone(RoutePathJSON, true);

    route.data.geometry.coordinates = latlngs;

    if (properties) {
      _.defaults(properties.style, route.data.properties.style);
      _.extend(route.data.properties, properties);
    }

    return route;
  },

  getRouteLabel: function (route, label) {
    var label = this.createRouteLabel(route.data, {
      label: label
    });

    return label;
  },

  createRouteLabel: function (geojson, properties) {
    var label = _.clone(RouteLabelJSON, true);
    var coords = this._getRouteCentroid(geojson).geometry.coordinates;

    label.data.geometry.coordinates = coords;

    if (properties) {
      _.defaults(properties.style, label.data.properties.style);
      _.extend(label.data.properties, properties);
    }

    return label;
  },

  _getRouteCentroid: function (linestring) {
    var bbox = turfEnvelope(linestring);
    var center = turfCentroid(bbox);
    return center;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/route/lib/RouteUtil.js